/* eslint no-unused-vars: 1 */

/* Used in CMS Page-ID: 419608 */

var initMNPStatusApp = function() {
    'use strict';

    angular.module('mnp', [ 'mnp.common', 'mnp.modules', 'mnp.config'
    ]).run([ '$rootScope', '$state', '$stateParams', 'trackingSrv', function($rootScope, $state, $stateParams, trackingSrv) {
        $rootScope.$state = $state;
        $rootScope.$stateParams = $stateParams;

        $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            var siteStructure = trackingSrv.getSiteStructure();
            trackingSrv.trackPageView(siteStructure);
        });
    }

    ]).controller('mnpCtrl', function($scope) {

    }).config([ '$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {

        // ///////////////////////////
        // Redirects and Otherwise //
        // ///////////////////////////

        // Use $urlRouterProvider to configure any
        // redirects (when) and invalid urls
        // (otherwise).

        // The `when` method says if the url is ever the
        // 1st param, then redirect to the 2nd param
        // Here we are just setting up some convenience
        // urls.
        /*
         * .when('/c?id', '/contacts/:id').when( '/user/:id', '/contacts/:id')
         */

        // If the url is ever invalid, e.g. '/asdf',
        // then redirect to '/' aka the home state
        $urlRouterProvider.otherwise('/');

        /**
         * route for startpage
         */
        $stateProvider.state('home', {
            url: '/',
            templateUrl: window.PARTIALURL + '/status/initialScreen.html',
            controller: 'shopAuthCtrl',
            controllerAs: 'vm'

        /**
         * routes for login
         */
        }).state('mobileLogin', {
            url: '/shopLogin',
            templateUrl: window.PARTIALURL + '/login/CustomerData/login.msisdn.html',
            controller: 'shopAuthCtrl',
            controllerAs: 'vm'

        }).state('customerLogin', {
            url: '/meinVodafonelogin',
            templateUrl: window.PARTIALURL + '/login/myVF/login.customerAccount.html',
            controller: 'shopAuthCtrl',
            controllerAs: 'vm'

        }).state('contractChooser', {
            url: '/vertragwaehlen',
            templateUrl: window.PARTIALURL + '/porting.chooseContract.html',
            controller: 'shopAuthCtrl',
            controllerAs: 'vm'

        }).state('notAllowed', {
            url: '/andererVertragLogin',
            templateUrl: window.PARTIALURL + '/porting.otherLogin.html',
            controller: 'shopAuthCtrl',
            controllerAs: 'vm'

        /**
         * routes for porting-status
         */
        }).state('orderLogin', {
            url: '/rufnummern-mitnahme/orderdaten',
            templateUrl: window.PARTIALURL + '/status/login/login.order.html',
            controller: 'portingStatusCtrl',
            controllerAs: 'vm'

        }).state('porting-status', {
            url: '/rufnummern-mitnahme/status',
            templateUrl: window.PARTIALURL + '/status/porting.status.display.html',
            controller: 'portingStatusCtrl',
            controllerAs: 'vm',
            params: {
                orderId: null,
                firstname: null,
                lastname: null
            }

        }).state('reviseOrder', {
            url: '/rufnummern-mitnahme/status/bearbeiten',
            templateUrl: window.PARTIALURL + '/status/revise/revise.init-logged.html',
            controller: 'reviseOrderCtrl',
            controllerAs: 'vm'

        });

    }
    ]);
};
